import { effect, Injectable } from '@angular/core';
import { AppIndexedDb } from '../db';
import { DB_WYSIWYG_DATA_TABLE } from '../db-types';
import { currentUserId } from '../../current-user-id';
import { WysiwygDbType } from './wysiwyg-db.type';

@Injectable({ providedIn: 'root' })
export class WysiwygDb extends AppIndexedDb {

    public override tableName: string = DB_WYSIWYG_DATA_TABLE;

    constructor() {
        super();

        effect(async () => {
            currentUserId();
            await this.clearOnUserChange();
        });
    }

    /**
     * Creates a store - MUST be called within onupgradeneeded event
     */
    public initializeStore(db: IDBDatabase): void {
        const store = db.createObjectStore(this.tableName, {
            keyPath: 'id',
            autoIncrement: true,
        });
        store.createIndex('key', 'key', { unique: false });
    }

    public setDatabase(db: IDBDatabase): void {
        this.db = db;
    }

    public async store(key: string, html: string): Promise<void> {
        await this.add({
            key,
            html,
            storedAt: new Date(),
        } as WysiwygDbType);
    }

    public async deleteByKey(key: string) {
        const res = await this.promise<WysiwygDbType[]>(this.getStore().index('key').getAll(IDBKeyRange.only(key)));

        res.forEach((it: WysiwygDbType) => this.getStore('readwrite').delete(it.id));
    }

    public async listAllByKey(key: string): Promise<WysiwygDbType[]> {
        const res = await this.promise<WysiwygDbType[]>(this.getStore().index('key').getAll(IDBKeyRange.only(key)));
        return res || [];
    }
}
